import { defineStore } from 'pinia'
import { ref, watch } from 'vue'

export const useFavoritesStore = defineStore('favorites', () => {
    const STORAGE_KEY = 'favoriteYachts'

    // Load from sessionStorage on initialization
    const stored = sessionStorage.getItem(STORAGE_KEY)
    const favorites = ref(stored ? JSON.parse(stored) : [])

    const limitReached = ref(false)

    function toggleFavorite(yacht) {
        const index = favorites.value.findIndex(item => item.id === yacht.id)

        if (index === -1) {
            if (favorites.value.length >= 5) {
                limitReached.value = true
                return
            }
            limitReached.value = false
            favorites.value.push(yacht)
        } else {
            favorites.value.splice(index, 1)
        }
    }

    function isFavorite(yachtId) {
        return favorites.value.some(item => item.id === yachtId)
    }

    function removeFavorite(yachtId) {
        const index = favorites.value.findIndex(item => item.id === yachtId)
        if (index !== -1) {
            favorites.value.splice(index, 1)
        }
    }

    // Save to sessionStorage on every change
    watch(favorites, (newFavorites) => {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(newFavorites))
    }, { deep: true })

    return {
        favorites,
        toggleFavorite,
        isFavorite,
        removeFavorite,
        limitReached
    }
})
